import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiDialogContent = {
  styleOverrides: {
    root: {
      padding: '0 24px 24px',
      '&:first-of-type': { paddingTop: '24px' },
    },
  },
} satisfies Components<Theme>['MuiDialogContent'];
